import { createFileRoute } from "@tanstack/react-router";
import { KbPageView } from "@/features/knowledge-pages/KbPageView";

export const Route = createFileRoute("/kb/$orgSlug/$slug")({
  component: KbSlugRoute,
});

function KbSlugRoute() {
  const { orgSlug, slug } = Route.useParams();
  return <KbPageView mode={{ kind: "slug", orgSlug, slug }} />;
}
